import React from 'react';
import './ScheduleAndPrizes.css';
import { scheduleData, prizeData } from '../../config/scheduleAndPrizes';

const ScheduleAndPrizes = () => {
  return (
    <section className="schedule-prizes">
      <div className="section-block">
      <div className="section-title">
                <h2>Schedule</h2>
            </div>
<div className="schedule-grid">
  {scheduleData.map((item, index) => (
    <div key={index} className="schedule-row">
      <div className="schedule-label">{item.label}</div>
      <div className="schedule-date">{item.value}</div>
    </div>
  ))}
</div>

      </div>
      <div className="section-block">
      <div className="section-title">
                <h2>Prizes</h2>
            </div>
  
  <div className="prize-circles">
    {prizeData.slice(0, 3).map((item, index) => (
      <div key={index} className="prize-circle">
        <div className="prize-label">{item.label}</div>
        <div className="prize-value">{item.value}</div>
      </div>
    ))}
  </div>

  <div className="honorable-mention">
    <strong>{prizeData[3].label}:</strong> {prizeData[3].value}
  </div>
    <div className="honorable-mention">
  <strong>{prizeData[4].label}:</strong> {prizeData[4].value}
</div>
</div>

    </section>
  );
};

export default ScheduleAndPrizes;
